# Contract from backend draft PR Foris/darwined#5406 (EDH-015 / CHS-2756), paginated.
query InstructorTeachings($scenarioId: ID!, $originId: ID, $filter: TeachingFilterInput!) {
  data(scenarioId: $scenarioId, originId: $originId) {
    instructorTeachings(filter: $filter) {
      items {
        id
        contractedBlocks
        plannedBlocks
        difference
        courseComponent {
          id
          course {
            id
            code
            name
            __typename
          }
          component {
            id
            code
            name
            __typename
          }
          __typename
        }
        __typename
      }
      pageInfo {
        page
        size
        total
        hasNextPage
        hasPreviousPage
      }
      __typename
    }
    __typename
  }
}
